export const getFullPath = (filename = '') =>
  (process.env.REACT_APP_GCP_GS_URL || '') +
  (process.env.REACT_APP_GCP_GS_BUCKET || '') +
  (process.env.REACT_APP_GCP_GS_TERM_FOLDER || '') +
  filename;
